export class MPARequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "mpaPolicyIds",
            "baseName": "mpaPolicyIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "operation",
            "baseName": "operation",
            "type": "MPAOperationType",
            "format": ""
        },
        {
            "name": "requestMethod",
            "baseName": "requestMethod",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestPath",
            "baseName": "requestPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestBody",
            "baseName": "requestBody",
            "type": "string",
            "format": ""
        },
        {
            "name": "requesterUserId",
            "baseName": "requesterUserId",
            "type": "string",
            "format": ""
        },
        {
            "name": "requesterEmail",
            "baseName": "requesterEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "requesterName",
            "baseName": "requesterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "comment",
            "baseName": "comment",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "MPARequestStatus",
            "format": ""
        },
        {
            "name": "requiredApprovals",
            "baseName": "requiredApprovals",
            "type": "number",
            "format": ""
        },
        {
            "name": "currentApprovals",
            "baseName": "currentApprovals",
            "type": "number",
            "format": ""
        },
        {
            "name": "approvalExpiresAt",
            "baseName": "approvalExpiresAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "executionExpiresAt",
            "baseName": "executionExpiresAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "resolvedAt",
            "baseName": "resolvedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return MPARequest.attributeTypeMap;
    }
    constructor() {
    }
}
